import React from 'react';
import { Modal as AntModal, ModalProps } from 'antd';

// Criando uma interface que estende Modal com a propriedade confirm
interface ModalComponent extends React.FC<ModalProps> {
  confirm: typeof AntModal.confirm;
}

const Modal: ModalComponent = (props) => <Modal {...props} />;

// Adicionando 'confirm' ao componente Modal
Modal.confirm = AntModal.confirm;

export default Modal;
